'use client';

import {useEffect, useState} from 'react';

// useMediaQuery tracks a CSS media query.
// SSR-safe: starts false and resolves on mount.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, [query]);

  return matches;
}

// useIsMobile tracks whether the viewport is below the lg breakpoint (1024px).
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 1023px)');
}
